import React, { useState, useRef, useEffect } from "react";
import { Drawer } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import { updateShowGrcDrawer } from "../../../reducer/bookingReducer";
import { useReactToPrint } from "react-to-print";
import {
  bookingDetailsDrawerWidth,
  customCloseIconContainer,
} from "../../../utils/bookingDetailsHelper";

import GrcStructure from "../../common/Template/GrcStructure";
import { customerDetailsById } from "../../../services/customer";

const ViewGrcDrawer = () => {
  const dispatch = useDispatch();
  const [print, setPrint] = useState(false);
  const [customerData, setCustomerData] = useState({});

  const {
    showGrcDrawer,
    customerDetails,
    bookingDetails,
    paymentDetails,
    bookingHotelId,
    invoiceDetails,
  } = useSelector((store) => store.booking);

  const componentRef = useRef(null);
  const printPDF = useReactToPrint({
    onAfterPrint: () => setPrint(false),
    content: () => componentRef.current,
    documentTitle: "BookingsDetails",
  });
  const handleClose = () => {
    dispatch(updateShowGrcDrawer());
  };

  useEffect(() => {
    if (showGrcDrawer) {
      getCurrentCustomerData();
    }
  }, [customerDetails, showGrcDrawer]);

  const getCurrentCustomerData = async () => {
    let currentInvoiceId = invoiceDetails?.find(
      (Obj) => Obj?.type === "roomBill"
    )?.id;
    const payload = {
      hotelId: bookingHotelId,
      id: customerDetails?.[0]?.id,
      invoiceId: currentInvoiceId,
    };
    const response = await customerDetailsById(payload);
    if (response?.data) {
      setCustomerData(response?.data);
    }
  };

  return (
    <Drawer
      headerStyle={{ display: "none" }}
      closeIcon={<CloseOutlined style={customCloseIconContainer} />}
      onClose={handleClose}
      open={showGrcDrawer}
      width={bookingDetailsDrawerWidth}
    >
      {showGrcDrawer && (
        <GrcStructure
          bookingDetails={bookingDetails}
          paymentDetails={paymentDetails}
          customerData={customerData}
          handleClose={handleClose}
        />
      )}

      {print && (
        <GrcStructure
          bookingDetails={bookingDetails}
          paymentDetails={paymentDetails}
          customerData={customerData}
          val={componentRef}
        />
      )}

      <div className=" w-[100%] mt-2  absolute  bottom-0 right-0 ">
        <button
          className="w-[100%] text-fg-inverse py-3  bg-primary "
          onMouseEnter={() => setPrint(true)}
          onClick={printPDF}
          onMouseLeave={() => setPrint(false)}
        >
          PRINT
        </button>
      </div>
    </Drawer>
  );
};

export default ViewGrcDrawer;
